import { createReducer } from "reduxsauce";
import Actions from "modules/diagnostic/diagnostic-actions";

const INITIAL_STATE = {
  diagnostic: null,
  currentQuestion: null,
  painZones: {
    back: [],
    left: [],
    front: [],
    right: []
  },
  movingNext: false,
  changeAnswerConfirmed: false,
  answerGlowing: false,
  shouldAnimateQuestion: false,
  animateDirection: false
};

export const HANDLERS = {
  [Actions.Types.SET_ANIMATION_STATE]: (
    state,
    { animationDirection, animationState, animationAction, questionId }
  ) => ({
    ...state,
    animationDirection: animationDirection || state.animationDirection,
    animationState: animationState || state.animationState,
    animationAction: animationAction || state.animationAction,
    answerGlowing: questionId ? false : state.answerGlowing,
    currentQuestion: questionId ? questionId : state.currentQuestion
  }),
  [Actions.Types.INITIAL_DIAGNOSTIC_FETCHED]: (state, { diagnostic }) => ({
    ...state,
    diagnostic
  }),
  [Actions.Types.SET_CHANGE_ANSWER_CONFIRMED]: (
    state,
    { changeAnswerConfirmed }
  ) => ({
    ...state,
    changeAnswerConfirmed
  }),
  [Actions.Types.CURRENT_QUESTION_CHANGED]: (state, { questionId }) => ({
    ...state,
    currentQuestion: questionId,
    answerGlowing: false
  }),
  [Actions.Types.SET_ANSWER_GLOW]: (state, { answerGlowing }) => ({
    ...state,
    answerGlowing
  }),
  [Actions.Types.SET_MOVING_NEXT]: (state, { movingNext }) => ({
    ...state,
    movingNext
  }),
  [Actions.Types.PAIN_ZONES_FETCHED]: (
    state,
    { front, left, back, right }
  ) => ({
    ...state,
    painZones: {
      front,
      left,
      back,
      right
    }
  })
};

export default createReducer(INITIAL_STATE, HANDLERS);



// WEBPACK FOOTER //
// ./src/modules/diagnostic/diagnostic-reducer.js